import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useOfferTags } from 'cityads-v3/hooks/offers';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import darkTheme from 'cityads-v3/utils/muiTheme/darkTheme';
import { useOfferFiltersContext } from '../../OfferFilters.hooks';
import classes from './MayQuestBanner.scss'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export const MAY_QUEST_TAG = `may_quest`

const buttonTheme = createTheme({
  palette: {
    primary: {
      main: '#BC21FF'
    },
  },
});

export default function MayQuestBanner(): JSX.Element {
  const { t } = useTranslation(['main']);
  const [, tagsByCode] = useOfferTags()
  const offerFilters = useOfferFiltersContext()

  const handleSelectTag = useCallback(() => {
    if (offerFilters.selectedFilters.fields.tags.value.includes(MAY_QUEST_TAG)) {
      offerFilters.refresh()
    } else {
      offerFilters.selectedFilters.fields.tags.pushToArray(MAY_QUEST_TAG)
      offerFilters.selectedFilters.handleSubmit()
    }
  }, [offerFilters])

  if (!tagsByCode?.[MAY_QUEST_TAG]?.is_available_in_filter) {
    return null;
  }

  return (
    <MuiThemeProvider theme={darkTheme}>
      <div className={classes.container}>
        <div className={classes.banner}>
          <div className={classes.text}>
            <Typography
              color="textPrimary"
              variant="h6"
            >{t('mayQuest.title')}</Typography>
            <Typography color="textSecondary">{t('mayQuest.description')}</Typography>

            <MuiThemeProvider theme={buttonTheme}>
              <Button
                color="primary"
                classes={{ root: classes.button }}
                onClick={handleSelectTag}
                variant="contained"
              >{t('mayQuest.button')}</Button>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  )
}
